.gas-membership-plans-list {
    max-width: var(--gas-container-wide, 1180px);
    margin: 0 auto;
    padding: 42px 18px 56px;
    display: flex;
    flex-direction: column;
    gap: 28px;
}

.gas-membership-plans-list__header {
    max-width: 760px;
}

.gas-membership-plans-list__header-kicker,
.gas-membership-plans-list__eyebrow {
    color: var(--gas-color-primary, #2d6cdf);
    font-size: 12px;
    font-weight: 700;
    letter-spacing: 0.08em;
    text-transform: uppercase;
}

.gas-membership-plans-list__title {
    margin: 6px 0 0;
    font-size: clamp(32px, 4vw, 52px);
    line-height: 1.04;
    color: var(--gas-color-text, #1a1a1a);
}

.gas-membership-plans-list__subtitle {
    margin: 12px 0 0;
    font-size: 17px;
    line-height: 1.55;
    color: var(--gas-color-text-muted, #666);
}

.gas-membership-plans-list__grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(320px, 1fr));
    gap: 22px;
}

.gas-membership-plans-list__card {
    display: flex;
    flex-direction: column;
    gap: 16px;
    padding: 18px;
    border: 1px solid var(--gas-color-border, #e2e6ee);
    border-radius: 8px;
    background: var(--gas-color-surface, #fff);
    box-shadow: 0 18px 42px rgba(15, 23, 42, 0.08);
}

.gas-membership-plans-list__card-media {
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 190px;
    margin: -18px -18px 2px;
    overflow: hidden;
    border-radius: 8px 8px 0 0;
    background: linear-gradient(135deg, #f7fbff, #eef7f1 55%, #fff7ed);
    text-decoration: none;
}

.gas-membership-plans-list__card-image {
    width: 100%;
    height: 220px;
    object-fit: cover;
    display: block;
}

.gas-membership-plans-list__card-monogram {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 86px;
    height: 86px;
    border-radius: 50%;
    background: rgba(255, 255, 255, 0.78);
    color: var(--gas-color-primary, #2d6cdf);
    font-size: 28px;
    font-weight: 800;
    box-shadow: 0 10px 28px rgba(15, 23, 42, 0.12);
}

.gas-membership-plans-list__card-title {
    margin: 4px 0 0;
    font-size: 24px;
    line-height: 1.18;
    color: var(--gas-color-text, #1a1a1a);
}

.gas-membership-plans-list__card-link {
    color: inherit;
    text-decoration: none;
}

.gas-membership-plans-list__card-link:hover {
    text-decoration: underline;
}

.gas-membership-plans-list__card-meta {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 8px;
    margin: 0;
}

.gas-membership-plans-list__price {
    font-size: 20px;
    font-weight: 800;
    color: var(--gas-color-primary, #2d6cdf);
}

.gas-membership-plans-list__period {
    align-self: center;
    font-size: 13px;
    color: var(--gas-color-text-muted, #666);
}

.gas-membership-plans-list__badge {
    display: inline-block;
    padding: 4px 8px;
    border-radius: var(--gas-radius-pill, 999px);
    background: var(--gas-color-surface-alt, #eef2fb);
    color: var(--gas-color-primary, #2d6cdf);
    font-size: 12px;
    font-weight: 700;
}

.gas-membership-plans-list__card-description {
    margin: 0;
    line-height: 1.6;
    color: var(--gas-color-text, #1a1a1a);
}

.gas-membership-plans-list__features {
    list-style: none;
    margin: 0;
    padding: 0;
    display: flex;
    flex-direction: column;
    gap: 9px;
}

.gas-membership-plans-list__feature {
    position: relative;
    padding-left: 24px;
    color: var(--gas-color-text, #1a1a1a);
    line-height: 1.45;
}

.gas-membership-plans-list__feature::before {
    content: '✓';
    position: absolute;
    left: 0;
    color: var(--gas-color-success, #2e9e5b);
    font-weight: 800;
}

.gas-membership-plans-list__badges {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
}

.gas-membership-plans-list__notice {
    margin: 0;
    padding: 10px 12px;
    border-left: 3px solid var(--gas-color-warning, #e0a800);
    background: var(--gas-color-surface-alt, #fff8e6);
    color: var(--gas-color-text, #1a1a1a);
    border-radius: var(--gas-radius-sm, 4px);
}

.gas-membership-plans-list__notice--active {
    border-left-color: var(--gas-color-success, #2e9e5b);
    background: var(--gas-color-success-soft, #edf8f1);
}

.gas-membership-plans-list__card-actions {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
    margin-top: auto;
}

.gas-membership-plans-list__empty {
    text-align: center;
    color: var(--gas-color-text-muted, #666);
    padding: var(--gas-space-xl, 20px) 0;
}

.gas-membership-plans-list__advisor {
    text-align: center;
    margin-top: var(--gas-space-md, 10px);
}

@media (max-width: 640px) {
    .gas-membership-plans-list {
        padding: 28px 14px 40px;
    }

    .gas-membership-plans-list__grid {
        grid-template-columns: 1fr;
    }

    .gas-membership-plans-list__title {
        font-size: 34px;
    }

    .gas-membership-plans-list__card-actions {
        flex-direction: column;
        align-items: stretch;
    }

    .gas-membership-plans-list__card-actions .gas-button {
        justify-content: center;
    }
}
